import {
  FETCH_COMPANY,
  FETCH_COMPANY_SUCCESS,
  SHOW_COMPANY_MESSAGE,
  SHOW_COMPANY_LOADER,
  ON_UPDATE_COMPANY,
  UPDATE_COMPANY_SUCCESS,
  SHOW_BTN_UPDATE_COMPANY,
  ON_ADD_USER,
  ON_USER_CLOSE,
  HIDE_COMPANY_MESSAGE,
  SHOW_COMPANY_USERS_LOADER,
  FETCH_COMPANY_USERS,
  FETCH_COMPANY_USERS_SUCCESS,
  ON_UPDATE_COMPANY_USER,
  ON_UPDATE_COMPANY_USER_SUCCESS,
  ON_CREATE_COMPANY_USER,
  ON_CREATE_COMPANY_USER_SUCCESS
} from 'constants/ActionTypes';

export const fetchCompany = () => {
  return {
    type: FETCH_COMPANY,
  };
};
export const fetchCompanySuccess = (company) => {
  return {
    type: FETCH_COMPANY_SUCCESS,
    payload: company
  };
};
export const showBtnUpdateCompany = () => {
  return {
    type: SHOW_BTN_UPDATE_COMPANY,
  };
};
export const showCompanyLoader = () => {
  return {
    type: SHOW_COMPANY_LOADER
  };
};
export const showCompanydMessage = (message, messageStatus = false) => {
  return {
    type: SHOW_COMPANY_MESSAGE,
    payload: { message, messageStatus }
  };
};
export const onUpdateCompany = (data) => {
  return {
    type: ON_UPDATE_COMPANY,
    payload: data
  };
};
export const updateCompanySuccess = (data) => {
  return {
    type: UPDATE_COMPANY_SUCCESS,
    payload: data
  };
};
export const hideCompanyMessage = (data) => {
  return {
    type: HIDE_COMPANY_MESSAGE
  };
};
export const onAddUser = () => {
  return {
    type: ON_ADD_USER
  };
};
export const onUserClose = () => {
  return {
    type: ON_USER_CLOSE
  };
};
export const onUpdateCompanyUser = (user) => {
  return {
    type: ON_UPDATE_COMPANY_USER,
    payload: user
  };
};
export const showCompanyUsersLoader = (user) => {
  return {
    type: SHOW_COMPANY_USERS_LOADER,
    payload: user
  };
};
export const fetchCompanyUsers = () => {
  return {
    type: FETCH_COMPANY_USERS
  };
};
export const fetchCompanyUsersSuccess = (users) => {
  return {
    type: FETCH_COMPANY_USERS_SUCCESS,
    payload: users
  };
};
export const onUpdateCompanyUserSuccess = (data) => {
  return {
    type: ON_UPDATE_COMPANY_USER_SUCCESS,
    payload: data
  };
};
export const onCreateCompanyUser = (data) => {
  return {
    type: ON_CREATE_COMPANY_USER,
    payload: data
  };
}
export const onCreateCompanyUserSuccess = (data) => {
  return {
    type: ON_CREATE_COMPANY_USER_SUCCESS,
    payload: data
  };
};



// WEBPACK FOOTER //
// ./actions/Company.js